import React from 'react';
import styled from 'styled-components';

import { LeftErrorSpan } from './styles';

import { FormBlock as OriginalInputBlock, InputLabel } from '../commons/styles';

import Button from '../commons/component/button';

import { setFocusById } from '../commons/query';

import retrievePassword from '../api/account/password-retrieval.js';

const InputBlock = styled(OriginalInputBlock)`
  margin-bottom: 2.5rem;
  margin-top: 1rem;
  .form-control {
    display: block;
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  text-align: center;
  & > a,
  span {
    display: inline-block;
    cursor: pointer;
    width: 50%;
  }
  & > button {
    display: inline-block;
    width: 50%;
  }
`;

class ForgotPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: props.email,
      isFormSubmitting: false,
      errorMessage: ''
    };
    this.closePopUp = props.closePopUp;
  }

  render() {
    return (
      <div>
        <span>
          Identifique-se para receber um e-mail com as instruções e o link para criar uma nova
          senha.
        </span>
        <form onSubmit={this.submitPassword}>
          {this.state.errorMessage && <LeftErrorSpan>{this.state.errorMessage}</LeftErrorSpan>}
          <InputBlock id="email" column>
            <InputLabel>E-mail:</InputLabel>
            <input
              placeholder="Ex. joaodasilva@gmail.com"
              className="form-control"
              name="email"
              type="email"
              required
              value={this.state.email}
              onChange={this.handleChange}
            />
          </InputBlock>
          <ButtonWrapper>
            <span onClick={this.closePopUp}>cancelar</span>
            <Button
              primary
              disabled={this.state.isFormSubmitting}
              loading={this.state.isFormSubmitting}
            >
              Enviar senha
            </Button>
          </ButtonWrapper>
        </form>
      </div>
    );
  }
  submitPassword = event => {
    event.preventDefault();
    this.setState({ errorMessage: '', isFormSubmitting: true });
    retrievePassword(this.state.email)
      .then(this.props.onSuccess(this.state.email))
      .catch(this.handleError);
  };
  handleChange = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };
  handleError = () => {
    setFocusById('email');
    this.setState({
      isFormSubmitting: false,
      errorMessage: (
        <span>
          Ops! Algo não saiu como o esperado <br /> Tente novamente mais tarde
        </span>
      )
    });
  };
}

export default ForgotPasswordForm;
